module.exports = __webpack_public_path__ + "img/auburn-logo.e518b063.jpg";